module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/iterators.js
// module id = 269
// module chunks = 1